import { config } from './apiConfig';
import axios from 'axios';

const post = async (parameters) => {
    let AccessToken = localStorage.getItem('AccessToken');
    if (AccessToken) {
        let paramsBody = parameters.body;
        let response = await axios.post(`${config.url}/api/mvc/${parameters.ctrl}/${parameters.method}/${parameters.query}`,
            paramsBody,
            {
            headers: { "Authorization": `Bearer ${AccessToken}` }
        }).catch((err) => {
            return err.response;
        });
        return response;
    } else {
         window.location.href = 'https://iranhotelonline.com';
    }
}

export default post;